import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/insurers/insuranceRentability/store/insuranceRentabilitySlice/initialState.ts'

const insuranceRentabilitySlice = createSlice({
  name: 'insuranceRentability',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const InsuranceRentabilityActions = insuranceRentabilitySlice.actions
export const { reducer: insuranceRentabilityReducer } =
  insuranceRentabilitySlice
